import React from 'react';
import Stopwatch from '../Stopwatch';
import { create } from 'react-test-renderer';
import { render, screen } from '@testing-library/react';

describe('Stopwatch Component', () => {
  it('renders proper input when no option given', () => {
    render(<Stopwatch />);
    expect(screen.getAllByRole('textbox').length).toBe(4);
  });

  it('renders proper input when showSeconds and showMilliseconds given', () => {
    render(<Stopwatch showSeconds={false} showMilliseconds={false} />);
    expect(screen.getAllByRole('textbox').length).toBe(2);
  });

  it('renders proper input when showSeperators given', () => {
    render(<Stopwatch showSeperators />);
    expect(screen.getAllByRole('textbox').length).toBe(7);
  });

  it('renders secondary labels', () => {
    render(<Stopwatch showSecondaryLabels />);
    expect(screen.getByRole('textbox', { name: 'hrs' })).toBeInTheDocument();
    expect(screen.getByRole('textbox', { name: 'min' })).toBeInTheDocument();
    expect(screen.getByRole('textbox', { name: 'sec' })).toBeInTheDocument();
    expect(screen.getByRole('textbox', { name: 'msec' })).toBeInTheDocument();
  });

  it('renders label', () => {
    const labelMessage = 'label';
    render(<Stopwatch label='label' />);
    expect(screen.getByText(
      (content, element) => element.tagName.toLowerCase() === 'label' && content === labelMessage)
    ).toBeInTheDocument();
  });

  it('renders seconds', () => {
    render(<Stopwatch showSeconds={true} showMilliseconds={false} />);
    expect(screen.getAllByRole('textbox').length).toBe(3);
  });

  it('renders milliseconds', () => {
    render(<Stopwatch showSeconds={true} showMilliseconds={true} />);
    expect(screen.getAllByRole('textbox').length).toBe(4);
  });

  it('renders success message', () => {
    const successMessage = 'test message';
    render(<Stopwatch successMessage={successMessage} />);
    expect(screen.getByRole('img', { name: 'success' })).toBeInTheDocument();
    expect(screen.getByText(
      (content, element) => element.tagName.toLowerCase() === 'span' && content === successMessage)
    ).toBeInTheDocument();
  });

  it('renders error message', () => {
    const errorMessage = 'test message';
    render(<Stopwatch errorMessage={errorMessage} />);
    expect(screen.getByRole('img', { name: 'error' })).toBeInTheDocument();
    expect(screen.getByText(
      (content, element) => element.tagName.toLowerCase() === 'span' && content === errorMessage)
    ).toBeInTheDocument();
  });

  it('renders warning message', () => {
    const warningMessage = 'test message';
    render(<Stopwatch warningMessage='test message' />);
    expect(screen.getByRole('img', { name: 'warning' })).toBeInTheDocument();
    expect(screen.getByText(
      (content, element) => element.tagName.toLowerCase() === 'span' && content === warningMessage)
    ).toBeInTheDocument();
  });

  describe('snapshots', () => {
    it('should match all default props given snapshot', () => {
      const component = create(
        <Stopwatch 
          value={168000}
          focused='mm'
          disabled={false}
          showSeperators
          showMilliseconds={true}
          showSeconds={true}
          maxHours={24}
          showSecondaryLabels={true}
          infoMessage='test message'
          label="test label"
        />
      ).toJSON();
      expect(component).toMatchSnapshot();
    });
    it('should match disabled stopwatch snapshot', () => {
      const component = create(<Stopwatch disabled={true} />).toJSON();
      expect(component).toMatchSnapshot();
    });
  });
});
